import React from 'react';

import { checkIsDiscountBadgeShown } from '../helpers/checkIsDiscountBadgeShown';
import { UpsellItemsContainer } from './upsell-items/upsell-items.jsx';
import { Content } from '../components/content.jsx';
import { DiscountBadge } from '../components/discount-badge.jsx';
import { CartItems } from '../components/cart-items/cart-items.jsx';
import EmptyState from '../components/empty-state.jsx';

export const ContentContainer = ({ cart }) => {
  const isCartEmpty = cart.item_count === 0;
  const isDiscountBadgeShown = checkIsDiscountBadgeShown(cart.items);

  return (
    <Content>
      {isCartEmpty ? (
        <EmptyState />
      ) : (
        <>
          {isDiscountBadgeShown && <DiscountBadge />}
          <CartItems items={cart.items} />
          <UpsellItemsContainer />
        </>
      )}
    </Content>
  );
};
